import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../views/LandingPage.vue'
import Pricing from '../views/Pricing.vue'
import Login from '../views/Login.vue'
import VerifyEmail from '../views/VerifyEmail.vue'
import AcceptInvite from '../views/AcceptInvite.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Onboard from '../views/Onboard.vue'
import Create from '../views/Create.vue'
import Sites from '../views/Sites.vue'
import Editor from '../views/Editor.vue'
import Updates from '../views/Updates.vue'
import Team from '../views/Team.vue'
import Settings from '../views/Settings.vue'
import SiteSettings from '../views/SiteSettings.vue'
import AppShell from '../layouts/AppShell.vue'
import JobsDashboard from '../views/JobsDashboard.vue'
import Releases from '../views/Releases.vue'
import Social from '../views/Social.vue'
import GrowthDashboard from '../views/GrowthDashboard.vue'
import AnalyticsWorkspace from '../views/AnalyticsWorkspace.vue'
import Submissions from '../views/Submissions.vue'
import CapabilityMap from '../views/CapabilityMap.vue'
import CapabilityGrowth from '../views/CapabilityGrowth.vue'
import Campaigns from '../views/Campaigns.vue'

const requireAuth = (to, from, next) => {
  const token = localStorage.getItem('bwai_token')
  if (token) next()
  else next('/login')
}

const redirectIfAuth = (to, from, next) => {
  const token = localStorage.getItem('bwai_token')
  if (token) next('/sites')
  else next()
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Landing page — public, redirects authenticated users to /sites
    {
      path: '/',
      name: 'landing',
      component: LandingPage,
      beforeEnter: redirectIfAuth
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing,
    },

    // Public routes
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: redirectIfAuth
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: VerifyEmail,
    },
    {
      path: '/accept-invite',
      name: 'accept-invite',
      component: AcceptInvite,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
    },

    // Authenticated routes rendered inside the shared app shell
    {
      path: '/',
      component: AppShell,
      beforeEnter: requireAuth,
      children: [
        { path: '', redirect: '/sites' },
        { path: 'sites',   name: 'sites',        component: Sites   },
        { path: 'create',  name: 'create',        component: Create  },
        { path: 'updates', name: 'updates',        component: Updates },
        { path: 'team',    name: 'team',           component: Team    },
        { path: 'settings',name: 'settings',       component: Settings },
        { path: 'onboard', name: 'onboard',        component: Onboard },
        { path: 'dashboard', name: 'dashboard',    component: JobsDashboard },
        {
          path: 'sites/:id/settings',
          name: 'SiteSettings',
          component: SiteSettings,
          props: true
        },
        {
          // Commit-Selectable Release History view (AC001 onwards)
          path: 'sites/:id/releases',
          name: 'releases',
          component: Releases,
          props: true
        },
        {
          path: 'sites/:id/social',
          name: 'social',
          component: Social,
          props: true
        },
        {
          // Cross-Channel Performance + Lead Outcome Dashboard (BUI-F-14)
          path: 'sites/:id/growth',
          name: 'growth',
          component: GrowthDashboard,
          props: true
        },
        {
          // Submissions & export (BUI-F-18) — admin listing plus filtered
          // CSV/JSON export with async handling for large ranges
          path: 'sites/:id/submissions',
          name: 'submissions',
          component: Submissions,
          props: true
        },
        {
          // Analytics Operating Workspace (BUI-F-17) — site-scoped operator view
          path: 'sites/:id/analytics',
          name: 'analytics',
          component: AnalyticsWorkspace,

          props: true
        },
        {
          // Capability Map (Feature1 capability growth integration) —
          // site-scoped coverage of synced capabilities across website
          // communication and media campaigns
          path: 'sites/:id/capabilities',
          name: 'capabilities',
          component: CapabilityMap,
          props: true
        },
        {
          // Capability growth progress — per-capability engagement history
          // plus the site-wide channel picture. Replaces the retired
          // channel-first Growth dashboard as the Growth nav destination.
          path: 'sites/:id/growth-progress',
          name: 'growth-progress',
          component: CapabilityGrowth,
          props: true
        },
        {
          // Omnichannel campaigns (capability growth) — create -> generate wave
          // -> approve+schedule to Postiz; observation + recalibration next.
          path: 'sites/:id/campaigns',
          name: 'campaigns',
          component: Campaigns,
          props: true
        },
        {
          // Editor — rendered inside the app shell so it shares the main app
          // nav; the editor fills the area under the 52px nav bar.
          path: 'sites/:id/edit',
          name: 'editor',
          component: Editor,
          props: true
        }
      ]
    }
  ]
})

export default router
